export default __webpack_public_path__ + "static/media/cases_family_mart.de11a84d.png";